import React,{FC} from "react";

const AlertTextComponent : FC<{alertText: string}> = (props) =>{

    
    return (
        <p className='device-regpage-validation-message'>{props.alertText}</p>
    );
}

export default AlertTextComponent;